import React from 'react'
import UiRangeSlider from "../../../components/form/UiRangeSlider"
import {
    UiFilterWr,
    UiFilterTitle,
    UiFilterSeeMore,
    UiFilterContainer
} from "../../../components/common/UiFilterComponents"
import UiFiterInput from "../../../components/form/UiFilterInput"
import { UiCheckboxInput } from "../../../components/form/UiInput"


export default function ShopFilter(props) {

    return (
        <>
        
            <UiFilterWr>
                <UiFilterTitle title="Filter" />
                <UiFiterInput placeholder="Search Rewards" />
            </UiFilterWr>
            <UiFilterWr>
                <UiFilterTitle title="Popular Filters" />
                <UiCheckboxInput label="UK Getaway" />
                <UiCheckboxInput label="Smart Technologies" />
                <UiCheckboxInput label="Fashion" />
                <UiCheckboxInput label="Dining" />
                <UiFilterSeeMore />
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="Points Range" />
                <UiRangeSlider min={50} max={15000} />
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="Voucher Type" />
                <UiCheckboxInput label="Experience" />
                <UiCheckboxInput label="Travel" />
                <UiCheckboxInput label="Health & Beauty" />
                <UiFilterSeeMore />
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="Your Points Budget" />
                <UiCheckboxInput label="Less than  20k" />
                <UiCheckboxInput label="20k to 125k" />
                <UiCheckboxInput label="125k to 200k" />
                <UiCheckboxInput label="200k to 300k" />
                <UiCheckboxInput label="Greater than 300k" />
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="User Rating" />
                <UiCheckboxInput label="5 Star" />
                <UiCheckboxInput label="4 Star" />
                <UiCheckboxInput label="3 Star" />
            </UiFilterWr>
       

        </>
    )
}
